import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiResponse, PaginatedApiResponse } from '@card-software/nexus-utilities';
import { Business, BusinessSearch } from '../../models/finance/business';

@Injectable({
  providedIn: 'root',
})
export class BusinessProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.financeApi + '/api/v1/business';

  public search(businessSearch?: BusinessSearch, pageNumber = 1, pageSize = 300): Observable<ApiResponse<PaginatedApiResponse<Business>>> {
    return this.httpClient.post<ApiResponse<PaginatedApiResponse<Business>>>(
      `${this.baseUrl}/search?pageNumber=${pageNumber}&pageSize=${pageSize}`,
      businessSearch,
    );
  }

  public searchBatchIds(ids: string[]): Observable<ApiResponse<Business[]>> {
    return this.httpClient.post<ApiResponse<Business[]>>(`${this.baseUrl}/batch/ids`, ids);
  }
}
